import { render, staticRenderFns } from "./SucRadioFieldComponent.vue?vue&type=template&id=51c99e20&"
import script from "./SucRadioFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SucRadioFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports